import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {IRefreshable} from './shell.model';
import {AuthService} from '../auth/auth.service';
import * as Globals from '../common/globals';
import {IAuthorizationPolicyConfiguration} from "../auth/auth.policy.configuration";
import {AppConfigService} from "../app-config/app-config.service";

@Component({
    // host: {
    //    '(document:keyup)': '_keyup($event)',
    //    '(document:keydown)': '_keydown($event)',
    // },
    selector: 'shell',
    templateUrl: './shell.html',
    styleUrls: ['./shell.scss']
})

export class ShellComponent implements OnInit {

    public showAbout: boolean;
    public showChangePassword: boolean;

    public routedComponent: IRefreshable;
    public currUserName = "";
    public dropDownButtonItems: Array<any> = [
      { text: 'About', call: () => {this.showAbout = true}},
      { text: 'Change Password', call:() => {this.showChangePassword = true}},
      { text: 'Log Out', call: () => { return this.logout() }}
    ];

    public resources = {
        imgs: {
            CM: "./assets/images/RIS_CM_without_Philips.png"
        }
    };

   public passwordMinLength: number;
   public userPasswordPattern: number;

    constructor(private route: ActivatedRoute, private auth: AuthService, private appConfigService: AppConfigService, private router: Router) {
        this.currUserName = this.auth.getCurrUserName();
    }

    private logout()
    {
        this.auth.logout();
        this.router.navigate(['/login']);
    }

    public isPermit(componentName: string): boolean {
        return this.auth.isPermmitted(Globals.componentsPermissions[componentName]);
    }
    public onSplitButtonItemClick(dataItem: any) {
        dataItem.call();
    }

    private _keydown(event: KeyboardEvent) {
        if (event.keyCode === 116) {
            event.preventDefault();

            this.refresh();
            // this.router.navigateByUrl(this.router.url);
            // this.router.navigate(['/log-manager']);
            // let prevent = [13, 27, 37, 38, 39, 40]
            //    .find(no => no === event.keyCode);
            // if (prevent) event.preventDefault();
        }
    }

    private _keyup(event: KeyboardEvent) {
        // if (event.keyCode === 116) {
        //    event.preventDefault();
            // alert('/' + this.selectedTab);
            // this.router.navigate(['/ris-clients-state']);
        // }
        // else alert('no 116');
        //    else if (event.keyCode === 13) ...;
        // else if (event.keyCode === 37) ...;
        // else if (event.keyCode === 38) ...;
        // else if (event.keyCode === 39) ...;
        // else if (event.keyCode === 40) ...;

        // else console.log(event.keyCode);
    }

    // private selectedTab: string;
    // todos: Array<Object>;


    ngOnInit() {
      this.appConfigService.GetAuthorizationPolicyConfiguration().subscribe((configuration: IAuthorizationPolicyConfiguration) => {
        this.passwordMinLength = configuration.passwordMinLength;
        this.userPasswordPattern = configuration.userPasswordPattern;
      })
    }

    public refresh()
    {
        this.routedComponent.refresh();
    }
}
